var path = 'sidebar/sidebar.html';
var html = "<ul class=\"ns-sidebar-nav\">\n    <li class=\"ns-sidebar-nav__item\" ng-class=\"{ active: vm.isActivePath('/') }\">\n        <a class=\"ns-sidebar-nav__link\" href=\"#/\"></a>\n        <a class=\"ns-sidebar-nav__link\" href=\"#/\"></a>\n    </li>\n</ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/sidebar/sidebar.html
// module id = 11
// module chunks = 0